import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const exportsScreenModule = defineScreen({
  app: "coaching",
  screen_id: "exports",
  path: "/exports",
  heading: { text: "Exports", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "allow",
    "company_admin": "allow",
    "participant": "deny",
    "cohort_lead": "allow"
  },
  states: ["ready"],
  actions: [
    { id: "sort", kind: "secondary", driver: "table.sort" },
    { id: "filter", kind: "secondary", driver: "table.filter" },
    { id: "paginate", kind: "secondary", driver: "table.paginate" },
    { id: "row-open", kind: "row", driver: "table.rowOpen" }
  ],
  recipe: "ProTable-1",
  data: { seedNeeds: ["readonly-walk-session", "populated-list-min1"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/exports.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default exportsScreenModule;
